import { useEffect } from 'react';

export function useTimer(callback: Function, displayTimerInSec: number | null) {
	useEffect(() => {
		if (displayTimerInSec) {
			const displayTimerInMs = displayTimerInSec * 1000;
			setTimeout(callback, displayTimerInMs);
		} else {
			callback();
		}
	}, []);
}
